import { API, graphqlOperation } from 'aws-amplify'

import { getAnalytics, logEvent } from 'firebase/analytics'
import { BUILD_ENV, notifyBugsnag } from '.'
import { trackAnalyticsEvent } from '../graphql/mutations'
import i18n from '../i18n'
import { experimentProps } from './experiment'
import { getPartner } from './partner'
import { getSessionId } from './session'
import { getUser } from './user'

const extractErrorMessage = (err) =>
  err?.message ?? err?.errors?.[0]?.message ?? JSON.stringify(err)

export const trackEvent = (eventName, eventParams) => {
  const user = getUser()
  const partner = getPartner()
  const isLoggedIn = !!user?.id

  const attributes = {
    partner: partner?.id ?? '',
    user: user?.id ?? '',
    language: i18n?.language ?? '',
    // Segment (HubSpot-synced): GRUEN | GELB | ROT | '' — key for all
    // green-customer analyses (Rock Q3/26)
    lead_ampel: partner?.lead_ampel ?? '',
    // Per-tab session id → reconstruct user paths across events
    session_id: getSessionId(),
    route: window.location.pathname,
    // Laufende Experiment-Zuteilungen (exp_<key>: <variant>), siehe
    // src/features/experiments
    ...experimentProps(),
    ...eventParams
  }

  if (BUILD_ENV !== 'production') {
    console.log('trackEvent', eventName, attributes) // eslint-disable-line
    return
  }

  logEvent(getAnalytics(), eventName, attributes)

  if (!isLoggedIn) return

  API.graphql(
    graphqlOperation(trackAnalyticsEvent, {
      input: JSON.stringify({ event_name: eventName, data_json: attributes })
    })
  ).catch((err) =>
    notifyBugsnag(
      new Error(`trackAnalyticsEvent error: ${extractErrorMessage(err)}`)
    )
  )
}
